module.exports = __webpack_public_path__ + "media/images/new-deal 2-b149a7f99bbf2ae2ef00fd1463fe852d.png";